import base_url from '../baseUrls';
import ApiUtils from './apiUtils';

/**
 * Base URL for reporting and invoice data.
 *
 * These calls go through the iPermit backend (/api/reporting), which checks the
 * user's access token, limits the requested companies to the ones the user may
 * see, and then calls the reporting API with a key that stays on the server.
 * The routes mirror the reporting API's own (FactInspection/by-company,
 * Invoice/by-companyIds, ...), so callers only change the base URL and headers.
 *
 * Never put an API key for the reporting API in the portal: anything in the
 * bundle is readable by every visitor.
 */
export const REPORTING_API_BASE = `${base_url.api}reporting`;

/** Headers for a reporting call: the user's normal bearer token, plus any extras. */
export async function reportingHeaders(extra = {}) {
  const authToken = await ApiUtils.getAccessToken();
  return {...extra, ...(authToken ? {Authorization: authToken} : {})};
}
